import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as EpimsBankDetailActions from './bank-detail.actions';
import { EpimsBankDetailService } from '../../services/bank-detail.service';

@Injectable()
export class EpimsBankDetailEffects {
  loadEpimsBankDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EpimsBankDetailActions.loadEpimsBankDetail),
      exhaustMap(({ id }) =>
        this.bankService.getEpimsBankDetail(id).pipe(
          map((data) =>
            EpimsBankDetailActions.loadEpimsBankDetailSuccess({ bank: data })
          ),
          catchError((error) =>
            of(EpimsBankDetailActions.loadEpimsBankDetailFailure({ error }))
          )
        )
      )
    )
  );

  addEpimsBankDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EpimsBankDetailActions.addEpimsBankDetail),
      exhaustMap(({ newEpimsBankDetail }) =>
        this.bankService.createEpimsBankDetail(newEpimsBankDetail).pipe(
          map((data) => {
            this.notification.success('Saved Successfully');
            return EpimsBankDetailActions.addEpimsBankDetailSuccess({
              newEpimsBankDetail: data,
            });
          }),
          catchError((error) =>
            of(
              EpimsBankDetailActions.addEpimsBankDetailFailure({
                error: error.error.message,
              })
            )
          )
        )
      )
    )
  );

  updateEpimsBankDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EpimsBankDetailActions.updateEpimsBankDetail),
      map((action) => action.updateEpimsBankDetail),
      concatMap((updateEpimsBankDetail) =>
        this.bankService.updateEpimsBankDetail(updateEpimsBankDetail).pipe(
          map((_) => {
            this.notification.success('Updated Successfully');
            return EpimsBankDetailActions.updateEpimsBankDetailSuccess({
              updateEpimsBankDetail: updateEpimsBankDetail,
            });
          }),
          catchError((error) =>
            of(
              EpimsBankDetailActions.updateEpimsBankDetailFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  removeEpimsBankDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EpimsBankDetailActions.removeEpimsBankDetail),
      map((action) => action.ids),
      concatMap((ids) =>
        this.bankService.deleteEpimsBankDetail(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return EpimsBankDetailActions.removeEpimsBankDetailSuccess({ ids });
          }),
          catchError((error) =>
            of(
              EpimsBankDetailActions.updateEpimsBankDetailFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private bankService: EpimsBankDetailService,
    private notification: NotificationService
  ) {}
}
